
export const version = '1.0.5';
export const buildDate = '2026-08-21T18:28:07.725Z';
export const gitCommit = 'e7b028c';
export const fullVersion = '1.0.5-e7b028c';
